// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3Uk75","additionalInfo":"AgreementModal_additionalInfo__39Wrk"};